export function secondsToHours(seconds: number): number {
  const hours = seconds / 3600;

  if (!isFinite(hours) || hours === 0) return 0;

  // If 0.1h or more → 1 decimal
  if (Math.abs(hours) >= 0.1) {
    return +hours.toFixed(1);
  }

  // Otherwise → keep up to the first positive decimal digit
  const s = Math.abs(hours).toFixed(20); // e.g. "0.00138888888888888890"
  const frac = s.split('.')[1] ?? '';
  let leadingZeros = 0;
  while (leadingZeros < frac.length && frac[leadingZeros] === '0') leadingZeros++;

  const precision = Math.min(leadingZeros + 1, 3); // cap to avoid huge tails
  return +hours.toFixed(precision);
}
